import { Entity, ScheduleNonTask, TaskInstance } from '@common/types';
import { IconContent } from '@icons';
export class Appointment {
    taskInstances?: Entity<TaskInstance>[];
    taskInstanceKeys?: number[];
    scheduleNonTask?: ScheduleNonTask;
    startDate?: string;
    endDate?: string;
    assignedToId?: number;
    allDay?: boolean;

    assignedToName?: string;
    taskAlias?: string;
    taskName?: string;
    taskType?: string;
    location?: string;
    isLocked?: boolean;
    canDelete?: boolean;
    icon?: IconContent;
    animalCount?: number;
    taskCount?: number;
    resourceBackgroundColor?: string;
    resourceForegroundColor?: string;
    resourceGrouped: boolean | null;
    jobName?: string;
    effort?: number;
    duration?: number;
    taskStatusKey?: number;
    isGroup?: boolean;
}

